import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast, useLanguage } from 'hooks';
import { updateCustomerSettings } from 'modules/settings/api';

export const useMutationCustomerSettings = () => {
  const { t } = useTranslation();
  const { setLanguage } = useLanguage();
  const { successToast, errorToast } = useCustomToast();

  // Handles settings update
  const { mutate: setCompanySettings, isLoading } = useMutation(updateCustomerSettings, {
    onSuccess: async (response, _) => {
      setLanguage(response.data.languageCode);
      successToast(t('Your settings are successfully updated'));
    },
    onError: () => errorToast(),
  });

  return {
    setCompanySettings,
    isMutating: isLoading,
  };
};
